import { WebLink } from '@news-mono/web-common'
import React from 'react'
import {
    StyledHeadingFlexRow,
    StyledTitle,
} from './OlympicsWidgetHeading.styled'
import { OlympicWidgetLinks } from '../OlympicsWidgetLinks/OlympicsWidgetLinks'
import { GameOnParisLogo } from '../../logos/GameOnParis/GameOnParisLogo'

export interface OlympicWidgetHeadingProps {
    isFullSize: boolean
    pageType: string
}

function returnWidgetTitle(pageType: string) {
    return pageType.replace(/-/g, ' ')
}

export function OlympicWidgetHeading(props: OlympicWidgetHeadingProps) {
    const { isFullSize, pageType } = props

    return (
        <StyledHeadingFlexRow isFullSize={isFullSize}>
            <WebLink to="/sport/olympics/medal-tally">
                <StyledTitle isFullSize={isFullSize}>
                    {/* {returnWidgetTitle(pageType)} */}
                    MEDAL TALLY
                </StyledTitle>
            </WebLink>
            {isFullSize ? (
                <OlympicWidgetLinks
                    isFullSize={isFullSize}
                    pageType={pageType}
                />
            ) : (
                <WebLink to="/sport/olympics">
                    <GameOnParisLogo height={30} width={137} />
                </WebLink>
            )}
        </StyledHeadingFlexRow>
    )
}
